var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Watch } from "vue-property-decorator";
import axios from "axios";
import { throttle } from "lodash-es";
import Autocomplete from "./autocomplete.vue";
import { AddressCheckerStep } from "../declarations/enums";
import { TechnologyDetail } from "../services";
import WifiSignalIcon from "./shared/wifi-signal-icon.vue";
import { plansDetailService } from "../services/plans-detail.service";
import { sendToAnalytics } from "../mixins";
import { mixins } from "vue-class-component";
import 'core-js/features/promise';
var AddressChecker = /** @class */ (function (_super) {
    __extends(AddressChecker, _super);
    function AddressChecker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.AddressCheckerStep = AddressCheckerStep;
        _this.plansDetailService = plansDetailService;
        _this.name = "address-checker";
        _this.props = [];
        _this.autocompleteResults = [];
        _this.loading = false;
        _this.currentStep = AddressCheckerStep.START;
        _this.selectedAddressID = null;
        _this.availableTechnology = null;
        _this.upcomingTechnology = null;
        _this.errorMessage = null;
        _this.planLink = "#";
        _this.onInputThrottled = throttle(_this.onInput, 500);
        _this.lastAddressSearch = '';
        _this.touched = false;
        _this.proceed = true;
        _this.manualForm = {
            name: '',
            mobile: '',
            email: '',
            address: '',
            phone: '',
            department: '',
            flash: '',
            message: ''
        };
        _this.validNumber = true;
        _this.phoneNumberText = '1300 759 637';
        return _this;
    }
    AddressChecker.prototype.created = function () {
        // @TODO: Perhaps add another state if the page is loaded with an address in cookie? <-- @Keith.
        if (this.$cookies.isKey("addressId") &&
            (this.$cookies.get("addressId") !== -1 ||
                this.$cookies.get("addressId") !== "null")) {
            this.selectedAddressID = parseInt(this.$cookies.get("addressId"));
            this.onAddressSelected();
        }
        if (this.$cookies.isKey("availableTechnology") &&
            this.$cookies.get("availableTechnology") !== "null") {
            this.availableTechnology = this.$cookies.get("availableTechnology");
        }
        if (window.hasOwnProperty('phone_number_option')) {
            this.phoneNumberText = window.phone_number_option;
        }
    };
    AddressChecker.prototype.onInput = function (_a) {
        var _this = this;
        var value = _a.target.value;
        var url = window.api_url.replace(new RegExp('\/$'), '') + "/search_address?addr=".concat(encodeURI(value.replace(" ", "+")), "&id=1");
        this.lastAddressSearch = value;
        this.touched = true;
        if (value.length <= 5) {
            return;
        }
        axios.get(url).then(function (response) {
            if (response.status !== 200) {
                return;
            }
            _this.autocompleteResults = [];
            response.data.matches.map(function (match) {
                _this.autocompleteResults.push({
                    title: match.full_address,
                    value: match.address_id
                });
            });
            _this.autocompleteResults.push({
                title: "Cannot find your address?",
                value: -1
            });
        });
    };
    AddressChecker.prototype.onAddressChange = function (result) {
        if (result.value === -1) {
            this.currentStep = AddressCheckerStep.ADDRESS_NOT_FOUND;
        }
        this.selectedAddressID = result.value;
        this.onAddressSelected();
    };
    AddressChecker.prototype.onAddressSelected = function () {
        var _this = this;
        this.touched = true;
        if (!this.selectedAddressID && this.lastAddressSearch.length === 0) {
            return;
        }
        if (!this.selectedAddressID || this.selectedAddressID < 0) {
            this.currentStep = AddressCheckerStep.ADDRESS_NOT_FOUND;
            return;
        }
        this.currentStep = AddressCheckerStep.CHECKING_ADDRESS;
        this.plansDetailService
            .getServiceQualification(this.selectedAddressID)
            .then(function (response) {
            if (response.status !== 200) {
                return;
            }
            if (response.data.hasOwnProperty("qualification")) {
                var technology = response.data.qualification.technology;
                if (response.data.qualification.can_order === 0) {
                    _this.currentStep = AddressCheckerStep.SHOW_UPCOMING_TECH;
                    _this.upcomingTechnology = TechnologyDetail.getTechnologyDetails(technology);
                    return;
                }
                _this.currentStep = AddressCheckerStep.SHOW_AVAILABLE_TECH;
                _this.availableTechnology = TechnologyDetail.getTechnologyDetails(technology);
            }
        });
    };
    AddressChecker.prototype.onAddressReset = function () {
        this.sendToAnalytics({
            category: 'Form',
            action: 'Reset',
            label: 'Returned to beginning of address checker form',
        });
        this.selectedAddressID = null;
        this.availableTechnology = null;
        this.currentStep = AddressCheckerStep.START;
        this.autocompleteResults = [];
        this.lastAddressSearch = '';
        this.touched = false;
    };
    Object.defineProperty(AddressChecker.prototype, "planSelectorLink", {
        get: function () {
            if (!this.availableTechnology) {
                return '#';
            }
            if (this.availableTechnology.code === this.pageTechnology) {
                return '#plans';
            }
            return this.availableTechnology.link;
        },
        enumerable: false,
        configurable: true
    });
    AddressChecker.prototype.onPropertyChanged = function (value, oldValue) {
        // Do stuff with the watcher here.
    };
    AddressChecker.prototype.submitManualAddress = function () {
        var _this = this;
        var matches = this.manualForm.phone.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
        this.validNumber = matches ? true : false;
        this.manualForm.flash = this.validNumber ? '' : 'Invalid phone number';
        if (!this.validNumber) {
            return;
        }
        this.sendToAnalytics({
            category: 'SQ',
            action: 'Submit',
            label: 'Cannot find your address',
        });
        this.manualForm.department = 'sales';
        this.manualForm.message = "Please manually check my address not matched to the NBN Co's footprint list: ".concat(this.manualForm.address);
        this.proceed = false;
        axios.post(window.api_url.replace(new RegExp('\/$'), '') + '/contact_request', this.manualForm)
            .then(function (response) {
            if (response.data.status !== 'ok') {
                _this.errorMessage = response.data.error;
                _this.currentStep = AddressCheckerStep.ERROR;
                return;
            }
            _this.proceed = true;
            _this.currentStep = AddressCheckerStep.ADDRESS_SUBMITTED;
        });
    };
    AddressChecker.prototype.submitEmailNotification = function () {
        var _this = this;
        this.sendToAnalytics({
            category: 'SQ',
            action: 'Submit',
            label: 'SQ Notify me by email',
        });
        axios.post(window.api_url.replace(new RegExp('\/$'), '') + '/notify_availability', {
            address_id: this.selectedAddressID,
            email: this.manualForm.email
        })
            .then(function (response) {
            if (response.data.status !== 'ok') {
                _this.errorMessage = response.data.error;
                _this.currentStep = AddressCheckerStep.ERROR;
                return;
            }
            _this.currentStep = AddressCheckerStep.EMAIL_SUBMITTED;
        });
    };
    AddressChecker.prototype.onCurrentStepChange = function (newStep, oldStep) {
        if (oldStep === AddressCheckerStep.START) {
            this.sendToAnalytics({
                category: 'SQ',
                action: 'Submit',
                label: 'Address checked',
            });
        }
        if (newStep === AddressCheckerStep.ADDRESS_NOT_FOUND) {
            this.manualForm.address = this.lastAddressSearch;
        }
    };
    AddressChecker.prototype.onAvailableTechnology = function (newTechnology) {
        if (newTechnology === null) {
            this.$cookies.remove("availableTechnology");
        }
        else {
            this.$cookies.set("availableTechnology", newTechnology.code);
        }
        this.$emit('technology-changed', newTechnology && newTechnology.code);
    };
    AddressChecker.prototype.onSelectedAddressIDChange = function (newAddressID) {
        if (newAddressID === null) {
            this.$cookies.remove("addressId");
        }
        else {
            this.$cookies.set("addressId", newAddressID);
        }
        this.$emit('address-changed', newAddressID);
    };
    __decorate([
        Prop({ default: false, type: Boolean })
    ], AddressChecker.prototype, "hasSlot", void 0);
    __decorate([
        Prop({ default: false, type: Boolean })
    ], AddressChecker.prototype, "showOverlay", void 0);
    __decorate([
        Prop({ default: '', type: String })
    ], AddressChecker.prototype, "pageTechnology", void 0);
    __decorate([
        Prop({ default: '', type: String })
    ], AddressChecker.prototype, "introText", void 0);
    __decorate([
        Prop({ default: true, type: Boolean })
    ], AddressChecker.prototype, "colourTechnologyName", void 0);
    __decorate([
        Watch('manualForm.flash')
    ], AddressChecker.prototype, "onPropertyChanged", null);
    __decorate([
        Watch('currentStep')
    ], AddressChecker.prototype, "onCurrentStepChange", null);
    __decorate([
        Watch('availableTechnology')
    ], AddressChecker.prototype, "onAvailableTechnology", null);
    __decorate([
        Watch('selectedAddressID')
    ], AddressChecker.prototype, "onSelectedAddressIDChange", null);
    AddressChecker = __decorate([
        Component({
            components: { WifiSignalIcon: WifiSignalIcon, Autocomplete: Autocomplete },
        })
    ], AddressChecker);
    return AddressChecker;
}(mixins(sendToAnalytics)));
export default AddressChecker;
